import React from 'react';
import PropTypes from 'prop-types';
import { reduxForm, Field } from 'redux-form';

import { Input, TextArea } from '@zapsa/zap-redux-forms-components';

const validate = (values, props) => {
  const errors = {};
  if (!values.email) {
    errors.email = props.translations['contact.emailRequired'];
  }
  if (!values.message) {
    errors.message = props.translations['contact.messageRequired'];
  }
  return errors;
};

class ContactForm extends React.Component {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div>
        <form onSubmit={this.props.handleSubmit} className="u-flex u-flex-column u-flex-justify u-max-size">
          <div className="form-description u-mb-3">{this.props.translations['contact.contactDesc']()}</div>
          <div className="u-flex u-flex-row u-flex-align-items">
            <Field name="firstName" placeholder={this.props.translations['contact.firstName']} component={Input} />
            <Field
              name="lastName"
              placeholder={this.props.translations['contact.lastName']}
              component={Input}
              className="u-ml-2"
            />
          </div>
          <Field name="email" placeholder={this.props.translations['contact.email']} component={Input} />
          <Field name="message" placeholder={this.props.translations['contact.message']} component={TextArea} />
          <div>
            <button type="submit" className="contact-button">
              {this.props.translations['contact.send']}
            </button>
          </div>
        </form>
      </div>
    );
  }
}

const LoginForm = reduxForm({
  form: 'contactForm',
  validate,
})(ContactForm);

export default LoginForm;
